import { z } from 'zod';

import { BookTypeEnum, LevelEnum } from '../../enums';
import { uuidValidator } from '../../validators';

export const BookReferenceSchema = z.object({
  author: z.string().nullable(),
  content: z.string().optional(),
  id: uuidValidator,
  language: z.string().default('de'),
  levels: z.array(z.nativeEnum(LevelEnum)),
  title: z.string(),
  type: z.nativeEnum(BookTypeEnum),
  userId: uuidValidator,
});

export type IBookReferenceDto = z.infer<typeof BookReferenceSchema>;
